export default "__VITE_ASSET__DjlVHUPY__"